import { SortModel } from '../models';

export function parseOrders(orderParam: string | null): SortModel[] {
  const orders: SortModel[] = [];
  if (orderParam) {
    orderParam.split(',').forEach(orderStr => {
      const [field, direction] = orderStr.split('.');
      if (field && direction && (direction === 'asc' || direction === 'desc')) {
        orders.push({ field, order: direction as 'asc' | 'desc' });
      }
    });
  }
  return orders;
}
